(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const tabs = [...root.querySelectorAll('[data-perfume-tab]')];
    const panels = [...root.querySelectorAll('[data-perfume-panel]')];
    if (!tabs.length || !panels.length) return;

    const select = (id, focus = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.perfumeTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });

      panels.forEach((panel) => {
        const active = panel.dataset.perfumePanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab.dataset.perfumeTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else next = (index - 1 + tabs.length) % tabs.length;
        select(tabs[next].dataset.perfumeTab, true);
      });
    });

    select((tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0]).dataset.perfumeTab);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-perfume-notes]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
